import { ArrowLeft, Download, FilePlus2, FolderOpen, LogIn, Redo2, Save, Undo2 } from 'lucide-react'
import { useShallow } from 'zustand/react/shallow'
import { useEditor } from '../store/editor'
import { loginUrl } from '../lib/api'
import { saveNow } from '../lib/persist'
import { startNewProject } from '../lib/actions'
import { DASHBOARD_URL, PLAN_LABEL, planOf, plansUrl } from '../lib/plan'
import vaideoLogo from '../assets/vaideo-logo.svg'

function SaveState() {
  const { user, saving, dirty, savedAt, serverId } = useEditor(useShallow((s) => ({
    user: s.user, saving: s.saving, dirty: s.dirty, savedAt: s.savedAt, serverId: s.serverId,
  })))
  if (!user) return <span className="save-state">Guardado en este navegador</span>
  if (saving) return <span className="save-state">Guardando…</span>
  if (dirty) return <span className="save-state">Cambios sin guardar</span>
  if (savedAt || serverId) return <span className="save-state">Guardado en tu cuenta</span>
  return null
}

export default function TopBar() {
  const name = useEditor((s) => s.project.name)
  const canUndo = useEditor((s) => s.past.length > 0)
  const canRedo = useEditor((s) => s.future.length > 0)
  const user = useEditor((s) => s.user)
  const authChecked = useEditor((s) => s.authChecked)
  const hasClips = useEditor((s) => s.project.clips.length > 0)
  const s = useEditor.getState

  return (
    <div className="topbar">
      <div className="brand">
        <img className="logo" src={vaideoLogo} alt="Vaideo" />
        <span className="brand-sub">Editor</span>
      </div>
      <a className="btn ghost sm back-link" href={DASHBOARD_URL} title="Volver a tu panel de Vaideo"><ArrowLeft size={14} />Volver a Vaideo</a>
      <input
        className="project-name"
        value={name}
        onChange={(e) => s().mutate((p) => { p.name = e.target.value }, { history: false })}
        onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur() }}
        aria-label="Nombre del proyecto"
      />
      <SaveState />
      <div className="spacer" />
      <button className="btn ghost" onClick={startNewProject} title="Proyecto nuevo"><FilePlus2 size={16} />Nuevo</button>
      <button className="btn ghost" onClick={() => s().set({ dialog: 'projects' })} title="Mis proyectos"><FolderOpen size={16} />Abrir</button>
      <button className="btn ghost" onClick={() => saveNow()} title="Guardar (Ctrl+S)"><Save size={16} />Guardar</button>
      <div className="sep" />
      <button className="btn ghost icon" disabled={!canUndo} onClick={() => s().undo()} title="Deshacer (Ctrl+Z)"><Undo2 size={16} /></button>
      <button className="btn ghost icon" disabled={!canRedo} onClick={() => s().redo()} title="Rehacer (Ctrl+Y)"><Redo2 size={16} /></button>
      <div className="sep" />
      <button className="btn primary" disabled={!hasClips} onClick={() => s().set({ dialog: 'export', playing: false })}>
        <Download size={16} />Exportar
      </button>
      {authChecked && (user ? (
        <div className="userchip">
          {planOf(user) === 'free' ? (
            <a className="plan-badge free" href={plansUrl('editor-badge')} target="_blank" rel="noopener" title="Plan Free · Ver planes">{PLAN_LABEL.free}</a>
          ) : (
            <span className={`plan-badge ${planOf(user)}`} title={`Plan ${PLAN_LABEL[planOf(user)]}`}>{PLAN_LABEL[planOf(user)]}</span>
          )}
          <div className="avatar" title={user.email}>{(user.displayName || user.email).slice(0, 1).toUpperCase()}</div>
        </div>
      ) : (
        <a className="btn" href={loginUrl()}><LogIn size={16} />Iniciar sesión</a>
      ))}
    </div>
  )
}
